import algoliasearch from 'algoliasearch/lite'
import { computed } from 'vue'

export const useSearchClient = () => {
  const searchClient = computed(() => {
    return algoliasearch(
      import.meta.env.VITE_ALGOLIA_APP_ID,
      import.meta.env.VITE_ALGOLIA_API_KEY
    )
  });
  return { searchClient };
}
